/**
 * Playable characters. Each has a distinct starting deck + HP, biasing toward
 * an archetype but flexible. Full identities (passives/keystone relics) deepen
 * in the content phase.
 */

import type { CharacterId } from "../types";

export interface CharacterDef {
  id: CharacterId;
  name: string;
  maxHp: number;
  startingGold: number;
  /** Starting deck as a list of card defIds (duplicates allowed). */
  startingDeck: string[];
  startingProgram?: string;
  description: string;
}

export const CHARACTER_DEFS: Record<CharacterId, CharacterDef> = {
  ghost: {
    id: "ghost",
    name: "Ghost",
    maxHp: 70,
    startingGold: 99,
    startingDeck: [
      "strike",
      "strike",
      "strike",
      "strike",
      "defend",
      "defend",
      "defend",
      "defend",
      "infect",
      "scrub",
    ],
    startingProgram: "ghost_protocol",
    description:
      "Stealth runner. Leans Virus/DoT and Trace control — patient, lethal over time. " +
      "Keystone: Ghost Protocol (start fights with less Trace, a higher ceiling).",
  },
  breaker: {
    id: "breaker",
    name: "Breaker",
    maxHp: 80,
    startingGold: 99,
    startingDeck: [
      "strike",
      "strike",
      "strike",
      "strike",
      "strike",
      "defend",
      "defend",
      "defend",
      "defend",
      "barrier",
    ],
    startingProgram: "brute_loader",
    description:
      "Brute-force runner. Higher HP, leans Aggro/Armor — kick the door in. " +
      "Keystone: Brute Loader (start fights with Strength + Block).",
  },
};

export function getCharacterDef(id: CharacterId): CharacterDef {
  const def = CHARACTER_DEFS[id];
  if (!def) throw new Error(`Unknown character: ${id}`);
  return def;
}
